export default __webpack_public_path__ + "static/media/img-hifive-color.df18667b.svg";